// import SyllabusComplianceBatchFilter from "Pages/SyllabusCompliances/SyllabusComplianceBatchFilters";
// import SyllabusComplianceBatchTable from "Pages/SyllabusCompliances/SyllabusComplianceBatchTable";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useState, useContext, useEffect } from "react";
import {
  BASE_URL,
  GET_TEST_TYPE,
  SYLLABUS_COMPLIANCE_BATCHES,
} from "utilFunctions/Constants/urlConstants";
import dayjs from "dayjs";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { Card } from "reactstrap";
import Paginator from "utilFunctions/shared/Paginator";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import useMasterContext from "Context/MasterContext";
import { SyllabusCompliancesContext } from "Context/SyllabusCompliances";
import SyllabusComplianceBatchAntdTable from "Pages/SyllabusCompliances/SyllabusComplainceBatchAntdTable";
import SyllabusComplianceBatchAntdFilter from "Pages/SyllabusCompliances/SyllabusComplianceBatchAntdFilters";
import { StyledMainDiv } from "Pages/MyBatchesAntd/MyBatchesAntd";
const SORT_ASC = "ASC";
const date = new Date();
const month = String(date.getMonth() + 1); // Months are 0-based, so we add 1
const year = String(date.getFullYear()); // Get the last two digits of the year

const BranchHealthTableHeading = [
  { label: "Batch Name", value: "batchName" },
  { label: "Planned Lecture Status", value: "plLecStatus" },
  { label: "Upcoming test", value: "testType" },
  { label: "Test Date", value: "testDate" },
  { label: "Test Syllabus Status", value: "testSyllbStatus" },
];
function SyllabusCompliancesBatchMain() {
  const { screen }: any = useWindowSize();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { syllabusCompliances, setSyllabusCompliances } = useContext<any>(
    SyllabusCompliancesContext
  );
  const ToastDispatch = useContext(ToastContextDispatch);
  const { masters } = useMasterContext();
  const [BranchData, setBranchData] = useState<any>([]);
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [sortColumn, setSortColumn] = useState<any>("testDate");
  const [region, setRegion] = useState<any>();
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [branchOptions, setBranchOptions] = useState<any>([]);
  const [chipFields, setChipFields] = useState<any>(null);
  const currentDate = dayjs().format("MMM-YYYY");

  const [filterState, setFilterState] = useState<any>({
    region: null,
    stream:
      masters.streams && masters.streams[0] != undefined
        ? masters.streams[0]
        : null,
    testType: null,
    branchCode: null,
    month: currentDate,
    chipField: {},
  });
  const [pagination, setPagination] = useState({
    totalCount: "",
    totalPage: "",
    currentPage: "",
    nextPage: "",
    nextPageUrl: "",
    previousPageUrl: "",
  });
  const [testTypeListing, setTestTypeListing] = useState<any[]>([]);
  const [testSyllbStatus, setTestSyllabusStatus] = useState<any>([]);
  const { makeRequest: GetBranchData, loading: tableloading } = useGetApi(
    (data) => {
      if (
        data &&
        data["data"] &&
        data["data"]["syllabusComplianceBatchesReponse"] &&
        data["data"]["syllabusComplianceBatchesReponse"].length
      ) {
        setBranchData(data["data"]["syllabusComplianceBatchesReponse"] || []);
        setPagination({
          totalCount: data.totalCount,
          totalPage: data.totalPage,
          currentPage: data.currentPage,
          nextPage: data?.nextPage ? data.nextPage : 0,
          previousPageUrl: data?.previousPageUrl ? data.previousPageUrl : "",
          nextPageUrl: data?.nextPageUrl ? data.nextPageUrl : "",
        });
      } else {
        setBranchData([]);
      }
      setTestSyllabusStatus([]);
    },
    (error) => {
      setBranchData([]);
      setTestSyllabusStatus([]);
      if (error && error["response"] && error["response"]["data"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error["response"]["data"]["message"],
        });
      }
    }
  );
  const { makeRequest: GetTestTypes } = useGetApi(
    (data) => {
      if (data["data"] && data["data"] && data["data"].length) {
        setTestTypeListing(
          data["data"].map((ele: any) => ({
            value: ele.id,
            key: ele.id,
            label: ele.testType,
          }))
        );
      } else {
        setTestTypeListing([]);
      }
    },
    (error) => {
      setTestTypeListing([]);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const onSelectClickHandler = (data: any) => {
    let url = BASE_URL + SYLLABUS_COMPLIANCE_BATCHES;
    url = url + "?facultyId=" + data?.branchId;
    GetBranchData(url);
  };
  useEffect(() => {
    const url = BASE_URL + GET_TEST_TYPE;
    GetTestTypes(url);
  }, []);
  useEffect(() => {
    if (userInfo?.region && masters?.userAssignedBranches) {
      const userAllotedRegiondata = userInfo?.region.split(",");
      const regiondata: any = [];
      if (masters?.regions) {
        masters?.regions.map((item: any) => {
          if (userAllotedRegiondata.includes(String(item.id))) {
            regiondata.push({
              id: item.id,
              key: item.id,
              label: item.region,
              value: item.regionCode,
            });
          }
        });
        setRegion(regiondata);
        setRegion(masters?.regions);
      }
      if (Object.keys(syllabusCompliances).length) {
        const region =
          syllabusCompliances.region && syllabusCompliances.region != undefined
            ? syllabusCompliances.region
            : null;

        const branch = masters?.userAssignedBranches?.filter(
          (ele: any) => ele.regionCode === region?.regionCode
        );
        setBranchOptions(branch);
        setFilterState({
          region:
            syllabusCompliances.region &&
            syllabusCompliances.region != undefined
              ? syllabusCompliances.region
              : null,
          stream: syllabusCompliances.stream
            ? syllabusCompliances.stream
            : null,
          testType: syllabusCompliances?.testType,
          branchCode: syllabusCompliances["branchCode"],
          month: currentDate,
          chipField: {
            stream: syllabusCompliances.stream
              ? syllabusCompliances.stream
              : null,
            region:
              syllabusCompliances.region &&
              syllabusCompliances.region != undefined
                ? syllabusCompliances.region
                : null,
            month: currentDate,
          },
        });
        setChipFields({
          stream: syllabusCompliances.stream
            ? syllabusCompliances.stream
            : null,
          region:
            syllabusCompliances.region &&
            syllabusCompliances.region != undefined
              ? syllabusCompliances.region
              : null,
          month: currentDate,
        });
      } else {
        const region = masters.regions && masters.regions[0];
        const branch = masters?.userAssignedBranches?.filter(
          (ele: any) => ele.regionCode === region?.regionCode
        );
        const branchCode = branch && branch[0] != undefined ? branch[0] : null;
        setBranchOptions(branch);
        setFilterState({
          region:
            masters.regions && masters.regions[0] != undefined
              ? masters.regions[0]
              : null,
          stream:
            masters.streams && masters.streams[0] != undefined
              ? masters.streams[0]
              : null,
          test: null,
          branchCode: branchCode,
          month: currentDate,
          chipField: {
            stream:
              masters.streams && masters.streams[0] != undefined
                ? masters.streams[0]
                : null,
            region:
              masters.regions && masters.regions[0] != undefined
                ? masters.regions[0]
                : null,
            month: currentDate,
          },
        });
        setChipFields({
          stream:
            masters.streams && masters.streams[0] != undefined
              ? masters.streams[0]
              : null,
          region:
            masters.regions && masters.regions[0] != undefined
              ? masters.regions[0]
              : null,
          month: currentDate,
        });
      }
    }
  }, [
    masters.streams,
    masters?.regions,
    userInfo?.region,
    masters?.userAssignedBranches,
  ]);
  useEffect(() => {
    if (Object.keys(syllabusCompliances).length) {
      const url =
        BASE_URL +
        SYLLABUS_COMPLIANCE_BATCHES +
        "?sortBy=" +
        sortColumn +
        "&sortDir=" +
        sortOrder +
        "&month=" +
        month +
        "&year=" +
        year.slice(-2);
      const streamName = syllabusCompliances.stream
        ? syllabusCompliances.stream?.label
        : masters.streams && masters.streams[0] != undefined
        ? masters.streams[0]?.label
        : null;
      const branchCode = syllabusCompliances.branchCode
        ? syllabusCompliances.branchCode?.value
        : masters.userAssignedBranches &&
          masters.userAssignedBranches[0] != undefined
        ? masters.userAssignedBranches[0]?.value
        : null;
      GetBranchData(`${url}&stream=${streamName}&branchCode=${branchCode}`);
    } else if (
      masters.streams &&
      masters.streams[0] != undefined &&
      masters?.userAssignedBranches
    ) {
      const streamName =
        masters.streams && masters.streams[0] != undefined
          ? masters.streams[0]?.label
          : null;
      const region = masters.regions && masters.regions[0];
      const branch = masters?.userAssignedBranches?.filter(
        (ele: any) => ele.regionCode === region?.regionCode
      );
      const branchCode =
        branch && branch[0] != undefined ? branch[0]?.value : null;
      const url =
        BASE_URL +
        SYLLABUS_COMPLIANCE_BATCHES +
        "?sortBy=" +
        sortColumn +
        "&sortDir=" +
        sortOrder +
        "&month=" +
        month +
        "&year=" +
        year.slice(-2);
      GetBranchData(`${url}&stream=${streamName}&branchCode=${branchCode}`);
    }
  }, [
    userInfo,
    location,
    masters.streams,
    currentPage,
    limit,
    sortColumn,
    sortOrder,
    masters?.userAssignedBranches,
  ]);
  const applyFilter = (filterStateObj: any) => {
    setSyllabusCompliances(filterStateObj);
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        stream: filterStateObj.stream?.label,
        testType: filterStateObj.testType?.label,
        branchCode: Array.isArray(filterStateObj.branchCode)
          ? filterStateObj?.branchCode?.[0].value
          : filterStateObj?.branchCode?.value,
        month:
          dayjs(filterStateObj.month, "MMM-YYYY").get("month") + 1 || month,
        year:
          String(dayjs(filterStateObj.month, "MMM-YYYY").get("year")).slice(
            -2
          ) || year,
      };
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + SYLLABUS_COMPLIANCE_BATCHES;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
      }
      url = url + "&sortBy=" + sortColumn + "&sortDir=" + sortOrder;
      GetBranchData(`${url}`);
    }
  };
  const resetHandler = () => {
    const region = masters.regions && masters.regions[0];
    const streamName = masters.streams[0]?.label;
    const branch = masters?.userAssignedBranches?.filter(
      (ele: any) => ele.regionCode === region?.regionCode
    );
    const branchCode =
      branch && branch[0] != undefined ? branch[0]?.value : null;
    setBranchOptions(branch);
    const url = BASE_URL + SYLLABUS_COMPLIANCE_BATCHES;
    GetBranchData(
      `${url}?stream=${streamName}&sortBy=${sortColumn}&sortDir=${sortOrder}&branchCode=${branchCode}
      &month=${month}
      &year=${year}`
    );
    setFilterState({
      ...filterState,
      testType: null,
      region:
        masters.regions && masters.regions[0] != undefined
          ? masters.regions[0]
          : null,
      stream:
        masters.streams && masters.streams[0] != undefined
          ? masters.streams[0]
          : null,
      branch: null,
      branchCode: null,
      month: currentDate,
      chipField: {
        region:
          masters.regions && masters.regions[0] != undefined
            ? masters.regions[0]
            : null,
        stream:
          masters.streams && masters.streams[0] != undefined
            ? masters.streams[0]
            : null,
        month: currentDate,
      },
    });
    setChipFields({
      region:
        masters.regions && masters.regions[0] != undefined
          ? masters.regions[0]
          : null,
      stream:
        masters.streams && masters.streams[0] != undefined
          ? masters.streams[0]
          : null,
      month: currentDate,
    });
    setSyllabusCompliances({});
  };
  const onLimitChange = (limit: number) => {
    setLimit(limit);
  };

  return (
    <StyledMainDiv screen={screen}>
      {/* <SyllabusComplianceBatchFilter
        mode="branchHealth"
        onSelectClickHandler={(data: any) => onSelectClickHandler(data)}
        region={region}
        applyFilter={applyFilter}
        filterState={filterState}
        setFilterState={setFilterState}
        resetHandler={resetHandler}
        testTypeListing={testTypeListing}
        branchOptions={branchOptions}
        setBranchOptions={setBranchOptions}
      /> */}
      <SyllabusComplianceBatchAntdFilter
        mode="branchHealth"
        cardTitle={"Batch Status"}
        onSelectClickHandler={(data: any) => onSelectClickHandler(data)}
        region={region}
        applyFilter={applyFilter}
        filterState={filterState}
        setFilterState={setFilterState}
        resetHandler={resetHandler}
        testTypeListing={testTypeListing}
        branchOptions={branchOptions}
        setBranchOptions={setBranchOptions}
        chipFields={chipFields}
        setChipFields={setChipFields}
      />
      <SyllabusComplianceBatchAntdTable
        mode="branchHealth"
        tableloading={tableloading}
        tableHeading={BranchHealthTableHeading}
        tableData={BranchData}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
        setSortColumn={setSortColumn}
        setSortOrder={setSortOrder}
        filterState={filterState}
        testSyllbStatus={testSyllbStatus}
        setTestSyllabusStatus={setTestSyllabusStatus}
      />
      <div
        className={
          !["xs", "sm", "md"].includes(screen)
            ? "batchTableContainer pt-0 pb-1 d-none"
            : "ml-2 mr-2 d-none"
        }
      >
        <Card className="p-3 mb-2 mb-1">
          <Paginator
            module={"test"}
            pagination={pagination}
            pageChanged={(page: any) => setCurrentPage(page)}
            handlePaginationCall={(url: string) => {
              GetBranchData(url);
            }}
            totalItems={BranchData.length}
            limit={limit}
            onLimitChange={onLimitChange}
          />
        </Card>
      </div>
    </StyledMainDiv>
  );
}

export default SyllabusCompliancesBatchMain;
